import qs from "qs";
import axios from "axios";

const url = process.env.VUE_APP_API_BASE_URL;

/**
 * Mail Module V2 — API Service
 *
 * Routes: /api/v1/organizations/{orgId}/mail/...
 */
function getBaseUrl(orgId) {
  return `${url}/organizations/${orgId}/mail`;
}

/* =====================================================
 *                    MAIL TYPES
 * ===================================================== */

function listTypes(orgId, params = {}) {
  const options = {
    params,
    paramsSerializer: (params) => qs.stringify(params, { encode: false }),
  };
  return axios
    .get(`${getBaseUrl(orgId)}/types`, options)
    .then((r) => r.data.data || []);
}

function getType(orgId, typeId) {
  return axios
    .get(`${getBaseUrl(orgId)}/types/${typeId}`)
    .then((r) => r.data.data || {});
}

/* =====================================================
 *                  MAIL TEMPLATES
 * ===================================================== */

function listTemplates(orgId, params = {}) {
  const options = {
    params,
    paramsSerializer: (params) => qs.stringify(params, { encode: false }),
  };
  return axios
    .get(`${getBaseUrl(orgId)}/templates`, options)
    .then((r) => r.data.data || []);
}

function customizeTemplate(orgId, mailTypeId) {
  return axios
    .post(`${getBaseUrl(orgId)}/templates/customize/${mailTypeId}`)
    .then((r) => r.data.data || {});
}

function updateTemplate(orgId, templateId, data) {
  return axios
    .put(`${getBaseUrl(orgId)}/templates/${templateId}`, data)
    .then((r) => r.data.data || {});
}

function deleteTemplate(orgId, templateId) {
  return axios.delete(`${getBaseUrl(orgId)}/templates/${templateId}`);
}

function previewTemplate(orgId, data) {
  return axios
    .post(`${getBaseUrl(orgId)}/templates/preview`, data)
    .then((r) => r.data.data || {});
}

function previewRaw(orgId, data) {
  return axios
    .post(`${getBaseUrl(orgId)}/templates/preview-raw`, data)
    .then((r) => r.data.data || {});
}

function sendTest(orgId, data) {
  return axios
    .post(`${getBaseUrl(orgId)}/templates/send-test`, data)
    .then((r) => r.data || {});
}

/* =====================================================
 *            ORGANIZATION MAIL SETTINGS
 * ===================================================== */

function getSettings(orgId) {
  return axios
    .get(`${getBaseUrl(orgId)}/settings`)
    .then((r) => r.data.data || {});
}

function updateSettings(orgId, data) {
  return axios
    .put(`${getBaseUrl(orgId)}/settings`, data)
    .then((r) => r.data.data || {});
}

/* =====================================================
 *                    MAIL LOGS
 * ===================================================== */

function listLogs(orgId, params = {}) {
  const options = {
    params,
    paramsSerializer: (params) => qs.stringify(params, { encode: false }),
  };
  return axios.get(`${getBaseUrl(orgId)}/logs`, options).then((r) => ({
    data: r.data.data || [],
    meta: r.data.meta || {},
  }));
}

/* =====================================================
 *              ADMIN — GLOBAL LIST
 * ===================================================== */

function listAllTypes(params = {}) {
  const options = {
    params,
    paramsSerializer: (params) => qs.stringify(params, { encode: false }),
  };
  return axios.get(`${url}/mail/admin/types`, options).then((r) => ({
    data: r.data.data || [],
    meta: r.data.meta || {},
  }));
}

function getMailType(typeId) {
  return axios
    .get(`${url}/mail/admin/types/${typeId}`)
    .then((r) => r.data.data || {});
}

function updateDefaultTemplate(typeId, data) {
  return axios
    .put(`${url}/mail/admin/types/${typeId}/default`, data)
    .then((r) => r.data.data || {});
}

function createMailType(data) {
  return axios
    .post(`${url}/mail/admin/types`, data)
    .then((r) => r.data.data || {});
}

function sendTestAdmin(typeId, data) {
  return axios
    .post(`${url}/mail/admin/types/${typeId}/send-test`, data)
    .then((r) => r.data.data || {});
}

function updateMailType(typeId, data) {
  return axios
    .put(`${url}/mail/admin/types/${typeId}`, data)
    .then((r) => r.data.data || {});
}

/* =====================================================
 *                  LAYOUTS
 * ===================================================== */

function listLayouts(params = {}) {
  const options = {
    params,
    paramsSerializer: (params) => qs.stringify(params, { encode: false }),
  };
  return axios.get(`${url}/mail/admin/layouts`, options).then((r) => r.data.data || []);
}

function getLayout(layoutId) {
  return axios
    .get(`${url}/mail/admin/layouts/${layoutId}`)
    .then((r) => r.data.data || {});
}

function updateLayout(layoutId, data) {
  return axios
    .put(`${url}/mail/admin/layouts/${layoutId}`, data)
    .then((r) => r.data.data || {});
}

function createLayout(data) {
  return axios
    .post(`${url}/mail/admin/layouts`, data)
    .then((r) => r.data.data || {});
}

function previewLayout(layoutId, data) {
  return axios
    .post(`${url}/mail/admin/layouts/${layoutId}/preview`, data)
    .then((r) => r.data.data || {});
}

/* =====================================================
 *                    EXPORTS
 * ===================================================== */
export default {
  // Types
  listTypes,
  getType,

  // Templates
  listTemplates,
  customizeTemplate,
  updateTemplate,
  deleteTemplate,
  previewTemplate,
  previewRaw,
  sendTest,

  // Settings
  getSettings,
  updateSettings,

  // Logs
  listLogs,

  // Admin
  listAllTypes,
  getMailType,
  updateDefaultTemplate,
  createMailType,
  updateMailType,
  sendTestAdmin,

  // Layouts
  listLayouts,
  getLayout,
  createLayout,
  updateLayout,
  previewLayout,
};
